// Deep-import the ES5 UMD bundle (value import): this Angular 7 / webpack 4 toolchain
// can't parse @growthbook's ES2020 syntax in the modern build. /dist/bundle is ES5
// with @growthbook bundled in. (Type-only imports in ./FeatureToggle can stay on root.)
import { FeatureToggleClient } from '@risepeopleinc/feature_toggle_client_web/dist/bundle';
import { environment } from 'src/environments/environment';
export function jwtTokenGetter() {
    return localStorage.token;
}
var ɵ0 = { hasBackdrop: false }, ɵ1 = function () {
    var fTClient = new FeatureToggleClient({
        apiHost: environment.GROWTHBOOK_API_HOST,
        clientKey: environment.GROWTHBOOK_FRONTEND_SDK_KEY,
    });
    return fTClient;
}, ɵ2 = function (ftClient) {
    return function () { return Promise.all([ftClient.initialize()]); };
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
